/**
 * @file ConfirmDialog.tsx
 * @description Окно подтверждения кабинета (phase19.31) — замена системного
 * `confirm()`. Вопрос и ответ — через `useConfirm` (поднято из зоны «Склад»,
 * прежнее имя `WmsConfirmDialog` осталось реэкспортом).
 *
 * `AlertDialog`: мимо окна и по Esc не закрывается случайно — решение
 * принимается кнопками; на телефоне окно во весь экран (правило диалогов
 * < sm). Кнопки — стандартные кнопки темы (SC43): «Отмена» второстепенная,
 * действие — основная, у опасного — красная окончательного подтверждения.
 */

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./alert-dialog";
import { Button } from "./button";
import type { ConfirmRequest } from "./use-confirm";

interface Props {
  request: ConfirmRequest | null;
  onSettle: (ok: boolean) => void;
  /** Закрыли без выбора (Esc); нет — как «Отмена». Для `confirmChoice` — `ConfirmApi.dismiss`. */
  onDismiss?: () => void;
}

export function ConfirmDialog({ request, onSettle, onDismiss }: Props) {
  const close = onDismiss ?? (() => onSettle(false));
  return (
    <AlertDialog open={request !== null} onOpenChange={(open) => (!open ? close() : null)}>
      <AlertDialogContent fullScreen className="max-w-md gap-3">
        <AlertDialogHeader>
          <AlertDialogTitle>{request?.title}</AlertDialogTitle>
          {request?.description ? <AlertDialogDescription>{request.description}</AlertDialogDescription> : null}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="ghost" onClick={() => onSettle(false)}>
            {request?.cancel ?? "Отмена"}
          </Button>
          <Button variant={request?.danger ? "destructive-solid" : "default"} onClick={() => onSettle(true)}>
            {request?.action}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
